<template>
  <div>
	  <div class='row'>
		  <div class='col-lg-12'>
			  <h1 class='page-header'>Dashboard</h1>
		  </div>
	  </div>
	  <div class='row'>
		  <div class='col-lg-3 col-md-6'>
			  <div class='panel panel-black'>
				  <div class='panel-heading'>
					  <div class='row'>
						  <div class='col-xs-3'>
							  <i class='fa fa-user-plus fa-5x'></i>
						  </div>
						  <div class='col-xs-9 text-right'>
							  <div class='huge'>{{ summary.deceaseds_total }}</div>
							  <div>Verstorbene</div>
						  </div>
					  </div>
				  </div>
				  <a href='/deceaseds/'>
					  <div class='panel-footer'>
						  <span class='pull-left'>Zu den Verstorbenen</span>
						  <span class='pull-right'><i class='fa fa-arrow-circle-right'></i></span>
						  <div class='clearfix'></div>
					  </div>
				  </a>
			  </div>
		  </div>
		  <div class='col-lg-3 col-md-6'>
			  <div class='panel panel-green'>
				  <div class='panel-heading'>
					  <div class='row'>
						  <div class='col-xs-3'>
							  <i class='fa fa-battery-quarter fa-5x'></i>
						  </div>
						  <div class='col-xs-9 text-right'>
							  <div class='huge'>{{ summary.graves_free }}</div>
							  <div>Freie Gräber</div>
						  </div>
					  </div>
				  </div>
				  <a href='/graves/'>
					  <div class='panel-footer'>
						  <span class='pull-left'>Zu den Gräbern</span>
						  <span class='pull-right'><i class='fa fa-arrow-circle-right'></i></span>
						  <div class='clearfix'></div>
					  </div>
				  </a>
			  </div>
		  </div>
		  <div class='col-lg-3 col-md-6'>
			  <div class='panel panel-grey'>
				  <div class='panel-heading'>
					  <div class='row'>
						  <div class='col-xs-3'>
							  <i class='fa fa-object-group fa-5x'></i>
						  </div>
						  <div class='col-xs-9 text-right'>
							  <div class='huge'>{{ summary.areas_free }}</div>
							  <div>Freie Flächen</div>
						  </div>
					  </div>
				  </div>
				  <a href='/areas/'>
					  <div class='panel-footer'>
						  <span class='pull-left'>Zu den Flächen</span>
						  <span class='pull-right'><i class='fa fa-arrow-circle-right'></i></span>
						  <div class='clearfix'></div>
					  </div>
				  </a>
			  </div>
		  </div>
		  <div class='col-lg-3 col-md-6'>
			  <div class='panel panel-primary'>
				  <div class='panel-heading'>
					  <div class='row'>
						  <div class='col-xs-3'>
							  <i class='fa fa-users fa-5x'></i>
						  </div>
						  <div class='col-xs-9 text-right'>
							  <div class='huge'>{{ summary.customers_total }}</div>
							  <div>Kunden</div>
						  </div>
					  </div>
				  </div>
				  <a href='/customers/'>
					  <div class='panel-footer'>
						  <span class='pull-left'>Zur Kundenverwaltung</span>
						  <span class='pull-right'><i class='fa fa-arrow-circle-right'></i></span>
						  <div class='clearfix'></div>
					  </div>
				  </a>
			  </div>
		  </div>
	  </div>
  </div>
</template>

<script>
import axios from 'axios'

import store from 'root/store.js'
import { authCheck } from 'functions/auth_check.js'

export default {
	beforeRouteEnter (to, from, next) {
		const route = authCheck('dashboard')
		console.log(route)

		if (route === null) {
			next()
		} else {
			next(route)
		}
	},

	name: 'app',
	data () {
		return {
			dashboard: {
				deceaseds: 0,
				areas: [],
				customers: 0,
				graves: []
			}
		}
	},

	activated () {
		axios.get('/api/dashboard/?' + Date.now())
		.then(response => {
			this.dashboard.deceaseds = response.data.deceaseds
			this.dashboard.areas = response.data.areas
			this.dashboard.customers = response.data.customers
			this.dashboard.graves = response.data.graves

			this.$store.dispatch('loadModels', [
				'customers',
				'graves',
				'deceaseds',
				'areas',
				'zips',
				'contact_types',
				'address_types'
			])
		})
	},

	methods: {
		countFree ( aTotal, aValue, aIndex, aArray ) {
			return aValue.status === 0 ? aTotal + aValue.count : aTotal
		},

		countTotal ( aTotal, aValue, aIndex, aArray ) {
			return aTotal + aValue.count
		}
	},

	computed: {
		summary () {
			return typeof this.dashboard === 'undefined' ? {
				deceaseds_total: 0,
				customers_total: 0,
				graves_total: 0,
				graves_free: 0,
				areas_total: 0,
				areas_free: 0
			} : {
				deceaseds_total: this.dashboard.deceaseds,
				customers_total: this.dashboard.customers,
				graves_total: this.dashboard.graves.reduce(this.countTotal, 0),
				graves_free: this.dashboard.graves.reduce(this.countFree, 0),
				areas_total: this.dashboard.areas.reduce(this.countTotal, 0),
				areas_free: this.dashboard.areas.reduce(this.countFree, 0)
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// Dashboard.vue?fee7d0a8